import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { BrowserRouter, HashRouter, Route, Routes } from "react-router-dom";
import axios from "axios";
import { AuthProvider, UserManager } from 'oidc-react';
import Redirector from "./component/structure/Redirector";
import $ from 'jquery'
// @ts-ignore
window.jQuery = window.$ = $
// @ts-ignore
window.Def = require("autocomplete-lhc")
require('select2');

const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
);

const userManager = buildUserManager();

root.render(
    <React.StrictMode>
        <AuthProvider userManager={userManager}
                      autoSignIn={false}
                      onSignOut={() => {
                          axios.defaults.headers.common['Authorization'] = undefined
                          window.location.href = process.env.REACT_APP_SIGN_OUT_URL!
                      }}>
            <HashRouter>
                <App userManager={userManager}/>
            </HashRouter>
            <BrowserRouter>
                <Routes>
                    <Route path="/redirect" element={<Redirector/>}/>
                </Routes>
            </BrowserRouter>
        </AuthProvider>
    </React.StrictMode>
);

export function buildUserManager() {
    return new UserManager({
        authority: process.env.REACT_APP_AUTHORITY as string,
        client_id: process.env.REACT_APP_CLIENT_ID as string,
        redirect_uri: process.env.REACT_APP_FORMS_REDIRECT_URL as string,
        scope: "openid profile api://ebs/individual-experience/header.read",
        response_type: "code",
        metadata: {
            issuer: process.env.REACT_APP_AUTHORITY,
            authorization_endpoint: `${process.env.REACT_APP_AUTHORITY}/v1/authorize`,
            userinfo_endpoint: `${process.env.REACT_APP_AUTHORITY}/v1/userinfo`,
            end_session_endpoint: `${process.env.REACT_APP_AUTHORITY}/v1/logout`,
            jwks_uri: `${process.env.REACT_APP_AUTHORITY}/v1/keys`,
            token_endpoint: `${process.env.REACT_APP_AUTHORITY}/v1/token`
        }
    });
}
